import LayoutComponent from "../components/LayoutComponent";
import {Button, Form, Input} from "antd";
import {useState, useEffect} from 'react';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
import CompanySelector from "../components/CompanySelector";
import TextEditor from "../components/TextEditor";

const {TextArea} = Input;

export default function BlogSavePage(props){
    const {api} = useApi();
    let history = useHistory();

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        let id = props.match.params.id;
        load(id);
    }, [props.match.params.id])

    async function load(id){
        if(id){
            await api.get('/blog/get/' + id).then(resp => {
                form.setFieldsValue(resp.data);
            })
        }
    }

    async function save(values){
        if(props.match.params.id){
            let id = props.match.params.id;
            setLoading(true);
            await api.put('/blog/update/' + id, values).then(resp => {
                history.push('/blogs');
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            setLoading(true);
            await api.post('/blog/store', values).then(resp => {
                history.push('/blogs');
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    return (
        <LayoutComponent links={
            [
                {
                    title: 'Bloglar',
                    url: '/blogs'
                },
                {
                    title: 'Ekle-Düzenle',
                    url: ''
                },

            ]}
        >
            <div>
                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={save}
                    onFinishFailed={() => {}}
                >
                    <Form.Item
                        label="Başlık"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Başlık Giriniz',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Metin"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'Metin giriniz',
                            },
                        ]}
                    >
                        <TextEditor
                            value={form.getFieldValue('content')}
                            onChange={(value) =>form.setFieldsValue({ content: value })}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Teknopark"
                        name="CompanyId"
                        rules={[
                            {
                                required: true,
                                message: 'Teknopark giriniz',
                            },
                        ]}
                    >
                        <CompanySelector
                            value={form.getFieldValue('CompanyId')}
                            onChange={(value) =>form.setFieldsValue({ CompanyId: value })}
                        />
                    </Form.Item>
                    <div className="form-button">
                        <Button className="submit-btn" loading={loading}  type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </div>
                </Form>
            </div>
        </LayoutComponent>
    )
}